import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './locales/en';
import { si } from './locales/si';
import { ta } from './locales/ta';
import { LANGUAGE_STORAGE_KEY, isLanguage } from '@/stores/languageStore';

// Custom detector that reads the persisted Zustand store payload directly so
// detection agrees with the language store. Validates the value against the
// supported Language union before returning — a stray write under the same
// key won't trigger a missing-resource fallback.
const persistedZustandDetector = {
  name: 'persistedZustand',
  lookup() {
    if (typeof localStorage === 'undefined') return undefined;
    try {
      const raw = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      if (!raw) return undefined;
      const parsed = JSON.parse(raw) as { state?: { language?: unknown } };
      const value = parsed?.state?.language;
      return isLanguage(value) ? value : undefined;
    } catch (e) {
      console.warn('[i18n] failed to read persisted language', e);
      return undefined;
    }
  },
};

const detector = new LanguageDetector();
detector.addDetector(persistedZustandDetector);

void i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      si: { translation: si },
      ta: { translation: ta },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'si', 'ta'],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['persistedZustand', 'navigator'],
      caches: [],
    },
  });

export default i18n;
